export class NotLoadedError extends Error {
    readonly name: string = "NotLoadedError";

    constructor(message: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
